import React from 'react';
import {
  Box,
  BoxProps,
  Menu,
  MenuProps,
  styled,
  Theme,
  Typography,
  TypographyProps,
} from '@mui/material';
import { SystemStyleObject } from '@mui/system';

export const BoardDetailSx: SystemStyleObject<Theme> = {
  width: '100%',
  position: 'relative',
  '&.isRowDirection': {
    '--detail-comment-width': '420px',
    header: {
      top: 'var(--board-detail-offset-top, 0px)',
      left: 'calc(max(calc((100% - var(--page-max-width, 100%)) / 2), 0px) - 1px)',
      transform: 'none',
      paddingLeft: 'var(--board-detail-padding-X, 0px)',
      paddingRight: '16px',
    },
    '.board-content-wrap': {
      flexDirection: 'row',
      gap: 0,
      '.board-content': {
        minWidth: 0,
        flex: 1,
        paddingRight: '16px',
        borderRight: '1px solid var(--dk-line, #E7E9EC)',
      },
    },
    '.board-feedback-wrap': {
      width: 'var(--detail-comment-width, 0px)',
      height: '100vh',
      '#board-feedback': {
        boxSizing: 'border-box',
        position: 'fixed',
        top: '0px',
        bottom: 'calc(var(--extra-height, 0px))',
        overflowY: 'auto',
        width: 'var(--detail-comment-width, 0px)',
        padding: 'calc(var(--board-detail-offset-top, 0px) + 16px) 0 0 16px',
      },
    },
    '#comment-input-wrap': {
      position: 'sticky',
      bottom: 0,
      width: 'calc(var(--detail-comment-width, 0px) - 16px)',
      zIndex: 1,
      padding: '0 0 24px 0',
      backgroundColor: 'var(--dk-bg, white)',
    },
  },
};

export const BoardDetailHeaderSx: SystemStyleObject<Theme> = {
  position: 'fixed',
  top: 'var(--board-detail-offset-top, 0px)',
  left: '50%',
  transform: 'translateX(-50%)',
  width: '100%',
  maxWidth: 'var(--page-max-width, "none")',
  backgroundColor: 'var(--dk-bg-subtle, #F5F7F8)',
  borderBottom: '1px solid var(--dk-line, #E7E9EC)',
  paddingTop: '16px',
  paddingBottom: '16px',
  paddingLeft: 'var(--board-detail-padding-X, 0px)',
  paddingRight: '16px',
  zIndex: 2,
  '.board-title': {
    fontWeight: 500,
    fontSize: '20px',
    lineHeight: '28px',
    color: 'var(--dk-text, black)',
    backgroundColor: 'var(--dk-bg-subtle, #F5F7F8)',
    flex: 1,
  },

  '&.isMobile': {
    paddingTop: '14px',
    paddingBottom: '14px',
    backgroundColor: 'var(--dk-bg, #ffffff)',
    '.board-title': {
      backgroundColor: 'var(--dk-bg, #ffffff)',
    },
  },
  '&.isCompact': {
    '> h1': {
      margin: '0 !important',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
};

export const BackgroundBlockSx: SystemStyleObject<Theme> = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  height: '56px',
  backgroundColor: 'var(--dk-bg, white)',
  zIndex: 2,
};

export const BoardDetailSubText = styled(
  ({ children, ...props }: TypographyProps) => (
    <Typography
      component={'span'}
      fontSize={'16px'}
      color={'var(--dk-text, #000000)'}
      {...props}
    >
      {children}
    </Typography>
  ),
)(() => ({}));

export const BoardDetailMenu = styled(({ children, ...props }: MenuProps) => (
  <Menu
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    {...props}
  >
    {children}
  </Menu>
))({
  '& .MuiMenu-list': {
    width: '104px',
    padding: '6px 10px',
    borderRadius: '8px',
    boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.12)',
    '> li': {
      width: '100%',
      padding: '6px',
      margin: 0,
      fontSize: '14px',
      color: 'var(--dk-text, black)',
    },
  },
});

export const FileAttachmentWrapper = styled(
  ({ children, ...props }: BoxProps) => <Box {...props}>{children}</Box>,
)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '8px',
}));
